import Animation from './Animation';
import './Cast.css';

export default class Cast extends Animation {

	constructor (master, model) {

		super(master, 400, true);
		this.model = model;
		//this.loadAudio("draw");
	}

	run () {

		var el = document.querySelector(".card-autocast:not(.card-autocast-anim)");
		//var text = document.querySelector("#game-entity-" + this.entity + " .game-entity-main .game-entity-afflict-status:not(.status-anim) .game-entity-afflict-status-text");
		var img = document.querySelector(".card-autocast:not(.card-autocast-anim) img");
		if (el) {
			el.classList.add("card-autocast-anim");
			img.src = this.model.img;
			//text.textContent = this.status.name;
			setTimeout(() => el.classList.remove("card-autocast-anim"), 700);
		}
	}
}